module.exports = __webpack_public_path__ + "img/pic06.ae81839c.jpg";